// React Dependencies
import React from 'react';
import { createRoot } from 'react-dom/client';

class ApplicationRenderer {
	static render(Application, mountPoint = document.getElementById('root')) {
		// TODO - In the future if we want to introduce routing, add <Router> here...
		const root = createRoot(mountPoint);
		root.render(Application);
	}
}

export default ApplicationRenderer;